export const PHONE_MASK = '+7 (###) ###-##-##';
export const PHONE_REGEX = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/;
